import type { FormField } from "../types";

const getGraduationYears = () => {
	const dateArray: string[] = [];
	const currentYear = new Date().getFullYear();
	for (let i = 0; i < 10; i += 1) {
		const newDate = currentYear + i;
		dateArray.push(`${newDate}`);
	}
	return dateArray;
};

const fields: FormField[] = [
	{
		label: "Email",
		placeholder: "Enter email",
		type: "email-address",
		autoFocus: true,
		editable: true,
	},
	{
		label: "Name",
		placeholder: "Enter name",
		type: "default",
		autoFocus: false,
		editable: true,
	},
	{
		label: "School",
		placeholder: "Enter school",
		type: "default",
		autoFocus: false,
		editable: true,
	},
	{
		label: "Year",
		placeholder: "Enter year",
		type: "numeric",
		autoFocus: false,
		editable: true,
	},
	{
		label: "Date",
		placeholder: "Select date",
		type: "default",
		autoFocus: false,
		editable: false,
	},
];
const otpLength = 6;
const otpErrorMessage =
	"Sorry, that code is invalid or expired. Please check for typos, resend the code, or go back to try another email";
const invalidEmailErrorMessage = "Please enter a valid email address";
const emailInstructionMessage = (email: string) => {
	const isEduEmail = email.endsWith(".edu");
	return `If you do not receive an email, check your junk, spam, and recently deleted folders${isEduEmail ? ", or contact your IT administrator" : ""}`;
};
export {
	getGraduationYears,
	fields,
	otpLength,
	invalidEmailErrorMessage,
	otpErrorMessage,
	emailInstructionMessage,
};
